import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that scrolls to the top of the page when the route changes
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Use requestAnimationFrame to ensure this runs after DOM updates
        const resetScrollPositions = () => {
            // Reset document/window scroll
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;

            // Reset main content container
            const mainElement = document.querySelector('main');
            if (mainElement) {
                mainElement.scrollTop = 0;
            }

            // Reset all potentially scrollable containers
            const scrollableElements = document.querySelectorAll(
                '.overflow-y-auto, .overflow-auto, [class*="overflow-y"], [class*="overflow"]'
            );
            scrollableElements.forEach(element => {
                if (element.scrollTop > 0) {
                    element.scrollTop = 0;
                }
            });
        };

        // Run once immediately
        resetScrollPositions();

        // And run again after a very short delay to ensure it happens after any rendering
        requestAnimationFrame(() => {
            resetScrollPositions();

            // Try again after a slightly longer delay as a fallback
            setTimeout(resetScrollPositions, 50);
        });
    }, [pathname]);

    return null;
};

export default ScrollToTop; 